import './index.scss';
// import starSvg from '../../assets/icons/star.svg';
import sparklesSvg from '../../assets/icons/sparkles.svg';
// import duoSvg from '../../assets/icons/duo.svg';
import { useEffect, useRef, useState } from 'react';
import { AppCircularProgress } from '../../components/AppCircularProgress';
import { useApiHelper } from './apiHelper';
import downloadIconSvg from '../../assets/icons/download.svg';
import { showAlert } from '../../reduxActions/alert';
import { useAppDispatch, useAppSelector } from '../../storeHook';
// import uplLogo from '../../assets/images/upl_logo.png';
// import { SamplePrompts } from './SamplePrompts';
import { ChatHistory } from './chatHistory';
import { useLazyGetChatHistoryListQuery } from '../../services/agrocraftArtisan';
import { TGetChatHistoryListResponse } from '../../utils/types/agrocraftArtisan';
import TelegramIcon from '@mui/icons-material/Telegram';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import {
  CUSTOM_EVENTS,
  appLogEvent,
} from '../../utils/analytics';
import { ImageToPrompt } from './imageToPrompt';
import { useSearchParams } from 'react-router-dom';
import { LanguageSelect } from '../../components/languageSelect';
import { PromptToImageLoader } from './promptToImageLoader';
import { AspectRatio } from './promptSelections/aspectRatio';
import { ImageStyle } from './promptSelections/imageStyle';
import { ImageUpscale } from './imageUpscale';
import { ZoomOut } from './zoomOut';
import Tooltip from '@mui/material/Tooltip';
import AgriPixLogo from '../../assets/icons/AgriPix_logo.svg';

import { EditImage } from './editImage';
const FEATURE_CARDS = {
  light: [
    {
    icon: sparklesSvg,
    title: 'Ad Banners',
    description: 'To Create advertisement banners in 2mins',
  },
  ],
  dark: [
    {
      icon: sparklesSvg,
      title: 'Stock Images',
      description: 'Create stock images in a jiffy!',
    },
  ],
};
const placeholders: Record<string, string> = {
  en: 'E.G.- A farmer driving a red tractor through a golden wheat field under a clear blue sky',
  pt: 'E.X. - Um fazendeiro dirigindo um trator vermelho por um campo de trigo dourado sob um céu azul claro',
  es: 'E.J. - Un granjero conduce un tractor rojo a través de un campo de trigo dorado bajo un cielo azul claro',
  fr: 'E.X. - Un fermier conduisant un tracteur rouge à travers un champ de blé doré sous un ciel bleu clair',
};

export const AgrocraftArtisian: React.FC = () => {
  const [prompt, setPrompt] = useState('');
  const [language,selectedLanguage] = useState('')
  const [aspectRatio, setAspectRatio] = useState('1:1');
  const [imageStyle, setImageStyle] = useState('realistic');
  const [chatHistoryList, setChatHistoryList] = useState<
    TGetChatHistoryListResponse[] | undefined
  >();
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [
    isLoadingImageToPrompt,
    setIsLoadingImageToPrompt,
  ] = useState(false);
  const [isScrollToLatest, setIsScrollToLatest] =
    useState(true);
  // const [isEditingInProgress, setIsEditingInProgress] =
  //   useState<boolean>(false);
  // const [url, setUrl] = useState<string>('');
  const handleLanguageChange = (newValue: string) => {
    selectedLanguage(newValue);
  };
  const [getChatHistoryList] =
    useLazyGetChatHistoryListQuery();
  const dispatch = useAppDispatch();
  const {
    isLoadingImages,
    responseChat,
    downloadImage,
    handleNewSession,
    // chatHistoryList,
    sessionId,
    setSessionId,
    handleLoadMoreChat,
  } = useApiHelper();
 const theme = useAppSelector((state) => state.theme.theme);

  const [searchParams] = useSearchParams();
  const userId = searchParams.get('userId');
  const handleHistoryList = () => {
    getChatHistoryList({ fetchedForUserId: userId })
      .unwrap()
      .then((res) => {
        setChatHistoryList(res);
      })
      .catch((err) => {
        console.log('error', err);
        // this.utility.handleError(err);
      });
  };

  useEffect(() => {
    handleHistoryList();
  }, []);

  const onSubmit = () => {
    setIsScrollToLatest(true);
    if (prompt.split(' ').length < 5) {
      dispatch(
        showAlert({
          content: 'Prompt should be more than 5 words',
          severity: 'error',
        })
      );
      return;
    }
    appLogEvent(CUSTOM_EVENTS.PROMPT_SUBMITTED, {
      prompt,
      aspectRatio,
      imageStyle,
      sessionId,
    });
    handleNewSession(
      prompt,
      aspectRatio,
      imageStyle,
      sessionId
    ).then((res) => {
      if (res) {
        setPrompt('');
        handleHistoryList();
      }
    });
  };

  const onInputKeyDown = (
    e: React.KeyboardEvent<HTMLTextAreaElement>
  ) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      onSubmit();
      e.preventDefault();
    }
    if (e.key !== 'Enter' && !prompt) {
      appLogEvent(CUSTOM_EVENTS.STARTED_TYPING_A_PROMPT);
    }
  };
  const selectedFeatureCards =
    theme === 'dark'
      ? FEATURE_CARDS.dark
      : FEATURE_CARDS.light;
  const ref = useRef<null | HTMLDivElement>(null);
  const scrollToLatestChat = () => {
    const lastChildElement = ref.current?.lastElementChild;
    lastChildElement?.scrollIntoView({
      behavior: 'smooth',
      block: 'end',
      inline: 'nearest',
    });
  };

  useEffect(() => {
    if (responseChat?.length > 0 && isScrollToLatest) {
      scrollToLatestChat();
    }
  }, [responseChat]);

  const loadMoreImagesHandler = (chatId: number) => {
    setIsScrollToLatest(true);
    handleLoadMoreChat(
      chatId,
      aspectRatio,
      prompt,
      imageStyle
    ).then((res) => {
      if (res) {
        handleHistoryList();
      }
    });
  };

  useEffect(() => {
    const textareaEle = textareaRef.current;
    if (textareaEle) {
      textareaEle.style.height = 'auto'; // Reset height to auto to recalculate
      let scrollHeight = textareaEle.scrollHeight;
      if (scrollHeight < 55 || prompt.length < 50) {
        scrollHeight = 44;
      }
      textareaEle.style.height = `${scrollHeight}px`;
    }
  }, [prompt]);

  return (
    <>
      <PromptToImageLoader isLoading={isLoadingImages} />
      {isLoadingImageToPrompt && <AppCircularProgress />}
      <div className="agrocraft-artisian-container">
        <ChatHistory
          userId={userId}
          setSessionId={setSessionId}
          chatHistoryList={chatHistoryList}
        />
        <div className="content-box flex flex-col overflow-y-auto justify-between">
          {responseChat && responseChat?.length > 0 ? (
            <div className="response-chain" ref={ref}>
              {responseChat.map((responseImgs, index) => (
                <div
                  key={`${responseImgs?.Prompt}-${index}`}>
                  <div className="images-container">
                    {responseImgs?.ChatContents?.map(
                      (img) => (
                        <div
                          key={img.Content?.image_link}
                          className="image-wrapper">
                          <img
                            className="banner-img"
                            src={img.Content?.image_link}
                          />
                          <section className="image-actions">
                            {!userId && (
                              <ImageUpscale
                                img={img}
                                chatId={responseImgs.ChatId}
                                setIsScrollToLatest={
                                  setIsScrollToLatest
                                }
                              />
                            )}
                            {!userId &&
                              sessionId &&
                              responseImgs.Prompt &&
                              'outpaint_flag' in
                                img.Content && (
                                <ZoomOut
                                  img={img.Content}
                                  sessionId={sessionId}
                                  setIsScrollToLatest={
                                    setIsScrollToLatest
                                  }
                                  prompt={
                                    responseImgs.Prompt
                                  }
                                  chatId={
                                    responseImgs.ChatId
                                  }
                                />
                              )}
                            {!userId && (
                              <EditImage
                                imgURL={
                                  img.Content?.image_link
                                }
                              />
                            )}
                            <Tooltip title="Download image">
                              <a
                                onClick={() =>
                                  downloadImage(
                                    img.Content?.image_link
                                  )
                                }
                                target="_self"
                                download>
                                <img
                                  src={downloadIconSvg}
                                />
                              </a>
                            </Tooltip>
                          </section>
                        </div>
                      )
                    )}
                  </div>
                  {!userId &&
                    responseChat?.length - 1 === index &&
                    responseImgs?.LoadMore && (
                      <div className="load-more-img--container m-2.5">
                        Unhappy with the results -{' '}
                        <a
                          className="load-more-img--cta"
                          onClick={() => {
                            loadMoreImagesHandler(
                              responseImgs?.ChatId
                            );
                          }}>
                          Load more images
                        </a>
                      </div>
                    )}
                  <div className="ml-3 width-800">
                    <div className="mt-5">
                      {
                        responseImgs?.ChatContents?.[0]
                          ?.Content?.caption
                      }
                    </div>
                    <div className="mt-3">
                      {responseImgs['Prompt']}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="agro-craft-artisan">
              <div className="flex flex-col items-center">
                <img
                  src={AgriPixLogo}
                  alt="App Logo"
                  className="w-[159.49px] h-[45.25px] object-contain"
                />
              </div>
              <div className="flex gap-x-5 mt-7 ag-cards justify-center">
                {selectedFeatureCards.map((card) => (
                  <div
                    key={card.title}
                    className="feature-card">
                    {/* <img src={card.icon} /> */}
                    <div className="feature-icon-box">
                      <AutoAwesomeOutlinedIcon />
                    </div>
                    <div className="font-medium text-[18px] mt-3">
                      {card.title}
                    </div>
                    <div className="description">
                      {card.description}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {!userId && (
            <div className="samples-and-input">
              <div className="flex justify-between items-end text-blue_2f80ed mb-4">
                <div className="flex gap-3">
                  <AspectRatio
                    selectedValue={aspectRatio}
                    onChange={(val) => setAspectRatio(val)}
                  />
                  <ImageStyle
                    selectedValue={imageStyle}
                    onChange={(val) => setImageStyle(val)}
                  />
                  <ImageToPrompt
                    setPrompt={setPrompt}
                    setIsLoadingImageToPrompt={
                      setIsLoadingImageToPrompt
                    }
                  />
                </div>
                {/* <SamplePrompts /> */}
              </div>
              <div className="input-field">
                <LanguageSelect
                  onChange={handleLanguageChange}
                />
                <div className="vertical-line" />
                <textarea
                  id="prompt-textarea"
                  ref={textareaRef}
                  dir="auto"
                  rows={1}
                  className="m-0 w-full resize-none border-0
                py-[10px] max-h-[25dvh] pl-3 pr-4"
                  spellCheck="true"
                  placeholder= {placeholders[language]}
                  value={prompt}
                  onChange={(e) =>
                    setPrompt(e.target.value)
                  }
                  onKeyDown={onInputKeyDown}
                />
                <TelegramIcon
                  className="submit-btn"
                  onClick={onSubmit}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
